<div class="col-12 py-2 comment-container">
  <div class="p-2 col-12">
    <label for="comments" class="form-label w-100 side-panel-label">Comments</label>
    <label *ngIf="comments?.length === 0 && newComments.length === 0" for="commentedBy" class="form-label"
      >No Comments</label
    >
    <ng-container *ngFor="let comment of comments">
      <div class="row">
        <div class="col-12">
          <label for="commentedBy" class="comment-meta col-12">
            {{ comment?.employeeCode + ' (' + (comment?.createdDatetime | date : 'dd-MM-yyyy h:mm a') + ')' }}
          </label>
          <div class="pb-2 dotted-line col-12">
            <span class="label-value" [ngStyle]="{ 'white-space': 'pre-wrap' }">{{ comment?.comment }}</span>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="newComments.length > 0">
      <label for="commentedBy" class="form-label">Unsaved Comments</label>
      <ng-container *ngFor="let comment of newComments">
        <label for="commentedBy" class="form-label"
          >{{ comment?.employeeCode + ' ' }} {{ comment?.createdDatetime | date : 'dd-MM-yyyy h:mm a' }}</label
        >
        <textarea class="form-control" [value]="comment?.comment" [disabled]="true" appAutoHeight></textarea>
      </ng-container>
    </ng-container>
  </div>
</div>

<form [formGroup]="commentForm">
  <div class="row rwmxmobail">
    <div class="col-12 py-2">
      <div class="p-2" style="margin-top: -15px">
        <label for="newComment" class="form-label">Add new comment</label>
        <textarea
          class="form-control"
          rows="3"
          formControlName="comment"
          (keyup)="addComment()"
          [ngClass]="{ 'is-invalid': f[COMMENT].errors && f[COMMENT].touched }"></textarea>
        <div class="p-2" style="float: right">
          <div class="form-check form-check-inline noti">
            <input
              class="form-check-input"
              type="checkbox"
              id="inlineCheckbox1"
              value="option1"
              checked
              formControlName="notify"
              (change)="onNotifyChange()" />
            <label class="form-check-label" for="inlineCheckbox1">Notify</label>
          </div>
        </div>
        <app-validation
          [field]="COMMENT"
          [form]="commentForm"
          [error]="{ required: 'Add a comment', maxLength: 'Max 255 characters' }"></app-validation>
      </div>
    </div>
    <app-validation
      *ngIf="statusChange"
      [field]="COMMENT"
      [form]="commentForm"
      [error]="{
        required: 'Comment is mandatory',
        minLength: 'Comment should have minimum length of 5',
        maxLength: 'Comment length cannot exceed 255 characters'
      }"></app-validation>
  </div>
</form>
